import { RootState } from "../store";

export const selectMenuIsOpen = (state: RootState) => state.menu.isOpen;
